import { render, staticRenderFns } from "./ansTst.vue?vue&type=template&id=f4987bbc"
import script from "./ansTst.vue?vue&type=script&lang=js"
export * from "./ansTst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports